/**
 * Mnemosyne category for deal-share attachments (One Pager PDF, uploads).
 *
 * Proven from the only AICA_CREATE_DEAL_DETAILS ViewConfig in godzilla
 * (dev/staging/prod `66de969ce5facb8f7dc30b94`, org `0000000000000000`):
 * DEAL_TERMS has `page.categoryId: 835`. SELECT_INVESTORS has none.
 * `generateOnePager` / `documents.components` are **not** in that doc.
 *
 * `getDealFormConfig` passes `additionalDetailsConfig` (pages[]). We read
 * `page.categoryId` first. If a PNO overlay uses the deal-drawer field shape
 * (`documents.components[0].categoryId` on a BUTTON/UPLOAD field), walk that
 * too. `flowId` is not in this config — the drawer hardcodes 16.
 */
export function categoryIdFromDealConfig(configData: any): number | undefined {
    const pages = Array.isArray(configData?.pages) ? configData.pages : [];
    // Page-level first (the checked Godzilla shape: DEAL_TERMS.categoryId).
    // A nested field on an earlier page must not mask a later page.categoryId.
    for (const page of pages) {
        if (typeof page?.categoryId === 'number') return page.categoryId;
    }
    for (const page of pages) {
        const sections = Array.isArray(page?.config) ? page.config : [];
        for (const section of sections) {
            const fields = section?.config && typeof section.config === 'object' ? section.config : {};
            for (const field of Object.values(fields) as any[]) {
                const fromField = field?.documents?.components?.[0]?.categoryId;
                if (typeof fromField === 'number') return fromField;
            }
        }
    }
    return undefined;
}
